import { forwardRef } from 'react';
import { useFormContext, Controller, FieldValues, RegisterOptions } from 'react-hook-form';
import { getNestedErrorForm } from './form.utils';
import { InputDateSelect } from '../input-date-select';

interface ControllerInputDateSelectProps {
	name: string;
	label: string;
	information?: string;
	triggersName?: string | string[] | undefined;
	minDate?: Date;
	maxDate?: Date;
	disabled?: boolean;
	format?: 'ISO_STRING' | 'CREDIT_CARD' | 'EXPIRATION_DATE';
	rules?:
		| Omit<RegisterOptions<FieldValues, string>, 'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>
		| undefined;
}
export const ControllerInputDateSelect = forwardRef<HTMLInputElement, ControllerInputDateSelectProps>(
	function ControllerInputDateSelect(
		{ name, label, minDate, maxDate, rules, triggersName, format, disabled = false, ...props },
		ref
	) {
		const {
			trigger,
			control,
			formState: { errors },
			getValues
		} = useFormContext<FieldValues>();

		return (
			<Controller
				disabled={disabled}
				name={name}
				control={control}
				rules={rules}
				render={({ field }) => (
					<InputDateSelect
						{...field}
						{...props}
						ref={ref}
						onChange={(e) => {
							field.onChange(e);
							triggersName && getValues(triggersName.toString()) && void trigger(triggersName);
						}}
						label={label}
						minDate={minDate}
						maxDate={maxDate}
						format={format}
						errorMessage={getNestedErrorForm(errors, name)?.message}
					/>
				)}
			/>
		);
	}
);
